/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { IInstrumento } from '../../../services/api/dams/DamServices';
import { VSelectMonitoringFrequency } from '../../shared';
import { ColorsLimite } from '../../../environment';

interface PizeometroProps {
    data: IInstrumento
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    validations: any;
    handleFrenquencyChange: (newFrequency: string) => void;
    isReadOnly?: boolean;
}

export const Piezomentro: React.FC<PizeometroProps> = ({ data, handleChange, validations, handleFrenquencyChange, isReadOnly }) => {

    return (
        <Box width={'100%'}>
            <Grid container direction={'column'} padding={2} spacing={2}>
                <Grid container item direction={'row'} spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Dados do Instrumento</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Unidade de medida'}
                            id='unidade_medida'
                            value={data.unidade_medida || ''}
                            error={validations.unidade_medida}
                            onChange={handleChange}
                            required
                            InputProps={{
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Elevação do fundo'}
                            id='elevacao_fundo'
                            value={data.elevacao_fundo || ''}
                            error={validations.elevacao_fundo}
                            onChange={handleChange}
                            type='number'
                            required
                            InputProps={{
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Elevação do terreno'}
                            id='elevacao_terreno'
                            value={data.elevacao_terreno || ''}
                            error={validations.elevacao_terreno}
                            onChange={handleChange}
                            type='number'
                            InputProps={{
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Elevação da boca'}
                            id='elevacao_boca'
                            value={data.elevacao_boca || ''}
                            error={validations.elevacao_boca}
                            onChange={handleChange}
                            type='number'
                            required
                            InputProps={{
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Frequência de monitoramento'}
                            id='freq_monit'
                            value={data.freq_monit || ''}
                            error={validations.freq_monit}
                            onChange={handleChange}
                            type='number'
                            required
                            InputProps={{
                                readOnly: isReadOnly || false,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <VSelectMonitoringFrequency
                            initFrequency={data.freq_monit_medida || ''}
                            onTypeChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                            disabled={isReadOnly || false} 
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Limites</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Limite Normal'}
                            id='limite_faixa_verde'
                            value={data.limite_faixa_verde || ''}
                            onChange={handleChange}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.verde },
                                readOnly: isReadOnly || false, 
                            }}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            type='number'
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Limite Atenção'}
                            id='limite_faixa_amarela'
                            value={data.limite_faixa_amarela || ''}
                            onChange={handleChange}
                            type='number'
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.amarelo },
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Limite Alerta'}
                            id='limite_faixa_laranja'
                            value={data.limite_faixa_laranja || ''}
                            onChange={handleChange}
                            type='number'
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.laranja },
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Limite Emergência'}
                            id='limite_faixa_vermelha'
                            value={data.limite_faixa_vermelha || ''}
                            onChange={handleChange}
                            type='number'
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.vermelho },
                                readOnly: isReadOnly || false, 
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};